import React from 'react';
import './ResultTable.css'; // R1.0.7

// R2.4.2 ★ 到着時間ロジックを共通関数化（PC/モバイル両方で使う）
function renderArrivalTime(item) {
  if (!item.到着時刻) return '-';

  // 1. 休憩時間（カッコ）が含まれている場合
  if (item.到着時刻.includes('（')) {
    const main = item.到着時刻.split('（')[0];
    const rest = item.到着時刻.split('（')[1];
    return (
      <span className="arrival-time-wrapper">
        <span className="arrival-time-main">{main}</span>
        <span className="rest-time-sub">{`（${rest}`}</span>
      </span>
    );
  }

  // 2. カッコが含まれていない場合（Skip 判定）
  const name = (item.区分名称 || '').toUpperCase().trim();
  const kbn = (item.区分 || '').toUpperCase().trim();

  const isStartOrFinish =
    name.includes('START') ||
    name.includes('FINISH') ||
    name.includes('FINSH') ||
    name.includes('GOAL') ||
    name.includes('スタート') ||
    name.includes('ゴール') ||
    kbn.includes('START') ||
    kbn.includes('FINISH') ||
    kbn.includes('FINSH') ||
    kbn.includes('GOAL');

  return (
    <span className="arrival-time-wrapper">
      <span className="arrival-time-main">{item.到着時刻}</span>
      {!isStartOrFinish && <span className="rest-time-sub">（Skip）</span>}
    </span>
  );
}

function ResultTable({ data }) {
  const isMobile = window.innerWidth < 600;

  if (!data || data.length === 0) {
    return <p>シミュレーション結果はありません。</p>;
  }

  return (
    <div className="result-table-container">

      {/* R2.4.2 📱 モバイル：カード UI */}
      {isMobile && (
        <div className="result-cards">
          {data.filter(item => item.区分 !== '').map((item, index) => (
            <div className="result-card" key={index}>
              <div className="rc-title">
                {item.区分} {item.区分名称}
                <span className="rc-distance">（{item.累積距離}km）</span>
              </div>

              <div className="rc-row">区間距離: {item.区間距離}km</div>
              <div className="rc-row">
                標高: {item.標高 !== null ? item.標高.toFixed(1) : '-'}m
              </div>

              {item.weatherIconUrl && (
                <div className="rc-row">
                  予想気温: {item.weatherTemp}
                  <img
                    src={item.weatherIconUrl}
                    alt="天気"
                    className="rc-weather-icon"
                  />
                </div>
              )}

              <div className="rc-row">
                到着時間: {renderArrivalTime(item)}
              </div>

              {item.関門時間 && (
                <div className="rc-row rc-gate">
                  関門時間: {item.関門時間}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* 🖥 PC：元の table ロジックを完全維持 */}
      {!isMobile && (
        <table className="result-table">
          <thead>
            <tr>
              <th>区分</th>
              <th>区分名称</th>
              <th>累積距離 (km)</th>
              <th>区間距離 (km)</th>
              <th>標高 (m)</th>
              <th>予想気温</th>
              <th>到着時間(休憩)</th>
              <th>関門時間</th>
            </tr>
          </thead>

          <tbody>
            {data.filter(item => item.区分 !== '').map((item, index) => (
              <tr key={index}>
                <td>{item.区分}</td>
                <td>{item.区分名称}</td>
                <td className="align-right">{item.累積距離}</td>
                <td className="align-right">{item.区間距離}</td>
                <td className="align-right">
                  {item.標高 !== null ? item.標高.toFixed(1) : '-'}
                </td>

                <td>
                  {item.weatherIconUrl ? (
                    <span className="weather-cell">
                      <img
                        src={item.weatherIconUrl}
                        alt="天気"
                        width="32"
                        height="32"
                      />
                      <span className="temp-text">{item.weatherTemp}</span>
                    </span>
                  ) : '-'}
                </td>

                <td>{renderArrivalTime(item)}</td>

                <td className={`align-right ${item.関門時間 ? 'red-text' : ''}`}>
                  {item.関門時間 || '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

    </div>
  );
}

export default ResultTable;
